export default __webpack_public_path__ + "1ae037390a0194bf5a992db6d33009af.svg";